import AgGridReact from 'ui/AgGridReact/AgGridReact';
import styled from '@mui/system/styled';

const ValueByDateGrid = styled(AgGridReact, { name: 'StyGrid' })({
    '&.ag-theme-material': {
        '& .ag-layout-auto-height': {
            '& .ag-center-cols-container': {
                minHeight: '36px',
            },
        },
        '.ag-header-cell, .ag-header-group-cell-with-group': {
            borderRight: 'var(--ag-cell-horizontal-border)',
            borderRightWidth: '1px',
        },
        '--ag-cell-horizontal-border': '2px solid #CCC',
    },
});

export default ValueByDateGrid;
